var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLemon = function SvgLemon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lemon_svg__a)",
    d: "M201.495 109.826c-38.019-59.971-129.342-35.5-143.3 20.55-2.506 10.065 19.219 62.908 72.7 64.585 42.8 1.343 71.345-32.323 77.709-57.875 1.671-6.71 4.178-6.71 5.013-10.065.947-3.8.184-7.9-2.507-10.065-4.184-3.356-7.91-4.435-9.615-7.13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lemon_svg__b)",
    d: "M59.8 125s.2 3 .2 7a22.2 22.2 0 0 1-.88 7S56 135 56 133s3.8-8 3.8-8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lemon_svg__a",
    x1: 125.395,
    x2: 136.725,
    y1: 194.76,
    y2: 74.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lemon_svg__b",
    x1: 60.976,
    x2: 55.072,
    y1: 131.916,
    y2: 131.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A99C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D2E5"
  })))));
};
export default SvgLemon;